import { render, staticRenderFns } from "./xmlTree.vue?vue&type=template&id=f543fc48&"
import script from "./xmlTree.vue?vue&type=script&lang=js&"
export * from "./xmlTree.vue?vue&type=script&lang=js&"
import style0 from "./xmlTree.vue?vue&type=style&index=0&id=f543fc48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports